module.exports = __webpack_public_path__ + "static/media/neha_pawar.068c4fcd.png";